export const mixinReportAuth = {
	created () {
		this.getAuthority()
	},
	methods: {
		getAuthority () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlNVPM}/reportScheme/getAuthority.do`
			}).then(res => {
				this.$store.commit({
					type: 'SETSTATE',
					reportAuth: res
				})
			}).catch(error => {
				console.log(error)
				this.$store.commit({
					type: 'SETSTATE',
					reportAuth: {}
				})
			})
		}
	}
}
